import { createContext, useContext, useState } from 'react';

type QuoteDrawerContextType = {
  isOpen: boolean;
  service?: string;
  openDrawer: (param?: React.MouseEvent | string) => void;
  closeDrawer: () => void;
};

const QuoteDrawerContext = createContext<QuoteDrawerContextType>({
  isOpen: false,
  openDrawer: () => {},
  closeDrawer: () => {}
});

export function QuoteDrawerProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [service, setService] = useState<string | undefined>();

  const openDrawer = (param?: React.MouseEvent | string) => {
    if (typeof param === 'string') {
      setService(param);
    }
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
    setService(undefined);
  };

  return (
    <QuoteDrawerContext.Provider value={{ isOpen, service, openDrawer, closeDrawer }}>
      {children}
    </QuoteDrawerContext.Provider>
  );
}

export const useQuoteDrawer = () => useContext(QuoteDrawerContext);
